const VENDOR_FILTERS = ["all", "spaces", "services"];

const getVendorFilterFromLocation = (
  location?:
    | {
        pathname?: string;
        query?: Record<string, string>;
      }
    | undefined,
) => {
  const filter = location?.query?.filter || "";

  return VENDOR_FILTERS.includes(filter) ? filter : "all";
};

export { getVendorFilterFromLocation };
